<template>
	<div class="app-table-container">
		<app-table
			class="mt-5 is-not-selectable"
			:current-page="currentPage"
			:last-page="lastPage"
			name="costs-centers"
			:columns="columns"
			:rows="rows"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="itemsQuantity"
			@create-action="createAction"
			@on-page="$emit('on-page', $event)"
			@row-is-selected="$emit('row-is-selected', $event)"
			@on-search-event="$emit('on-search', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable">
					{{ props.row.code }}
				</td>
				<td>{{ props.row.name }}</td>
				<td>{{ props.row.account }}</td>
				<td @click.stop="stopClick">
					<app-tooltip-button
						color="success"
						icon="edit"
						text="Editar Centro de Costos"
						:size="25"
						@click-icon="$emit('click-icon', 'edit', props.row)"
					/>
					<app-tooltip-button
						img="/static/img/actions-list/delete.svg"
						text="Eliminar Centro de Costos"
						:width="25"
						@click-icon="$emit('click-icon', 'delete', props.row)"
					/>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function createAction(action) {
	this.$emit('create-action', action);
}
function data() {
	return {
		iconWidth: 10,
	};
}
export default {
	name: 'cost-center-list',
	components: {
		appTooltipButton,
	},
	methods: {
		createAction,
	},
	data,
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		itemsTotalQuantity: {
			type: Number,
			default: 1,
		},
		itemsQuantity: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.app-table-container {
	padding-left: 5px;
	padding-right: 5px;

	@media (min-width: 768px) {
		padding-left: 35px;
		padding-right: 35px;
	}
}
.btnActions {
	margin: 0;
	background-color:#33cfc7;
	height:20px;
	width:20px;
}
.btnClose {
	margin: 0;
	background-color:#f58a93;
	height:20px;
	width:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/cost-centers/cost-center-list.vue